import { useTypedSelector } from '../redux/rootReducer'
import { selectTalentProfile } from '../redux/User/selector'

export function useTalentProfileCategory() {
  const talentProfile = useTypedSelector(selectTalentProfile)
  const { category } = talentProfile || {}
  return category
}
